import { createTheme } from '@mui/material';

const isCypress = typeof window !== 'undefined' && window.Cypress;

export const theme = createTheme({
  ...(isCypress && { transitions: { create: () => 'none' } }),

  palette: {
    primary: {
      main: '#629749',
    },
    secondary: {
      main: '#C49000',
    },
    dark: {
      main: '#414141',
      contrastText: '#fff',
    },
    primaryDark: {
      main: '#003d00',
      contrastText: '#fff',
    },
    slider: {
      main: 'rgba(0, 0, 0, 0.54)',
    },
    background: {
      main: '#f8f8f8',
    },
  },
  typography: {
    button: {
      textTransform: 'none',
    },
    body2: {
      fontSize: '0.875rem',
    },
    subtitle2: {
      color: 'rgba(0, 0, 0, 0.54)',
      fontSize: '13px',
      fontWeight: 400,
    },
    h5: {
      color: 'rgba(0, 0, 0, 0.87)',
      fontWeight: 500,
    },
    code: {
      fontFamily: 'monospace',
      whiteSpace: 'pre',
    },
  },
  components: {
    MuiSelect: {
      defaultProps: {
        variant: 'standard',
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          padding: 12,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#414141',
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          '&.legacy .MuiInputLabel-shrink': {
            transform: 'translate(14px, 0) scale(0.75)',
          },
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& .MuiTypography-body1': {
            fontSize: '0.875rem',
          },
        },
      },
    },
    MuiAlert: {
      styleOverrides: {
        standardError: {
          borderLeft: '4px solid rgb(95, 33, 32)',
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          borderRadius: 0,
        },
        columnHeaders: {
          borderRadius: 0,
        },
        columnHeader: {
          backgroundColor: '#f8f8f8',
        },
        columnHeadersInner: {
          backgroundColor: '#f8f8f8',
        },
        columnSeparator: {
          color: 'transparent',
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          backgroundColor: '#f8f8f8',
        },
      },
    },
  },
});
